import { createTheme } from "./utils/mui-imports";

export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(0, 0, 0)', // Deep purple
    },
    secondary: {
      main: 'rgba(1,1,1,1)', // Gold
    },
    background: {
      default: '#F5F5F5', // Light gray
      paper: '#FFFFFF',   // White
    },
    text: {
      primary: '#333333',   // Dark gray
      secondary: '#666666', // Lighter gray
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  shape: {
    // borderRadius: 8,
  },
});
